import { render, staticRenderFns } from "./privacyGold.vue?vue&type=template&id=ce6db89a"
import script from "./privacyGold.vue?vue&type=script&lang=js"
export * from "./privacyGold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports